// extracted by mini-css-extract-plugin
export default {"container":"image_container__I-wSU","overlayDesc":"image_overlayDesc__bufw5","overlayAuthor":"image_overlayAuthor__aXqYD","desc":"image_desc__BntLC"};